module.exports = __webpack_public_path__ + "img/03-cnpj.1091f75c.png";